import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';

import { BrowseButtonDetails } from './interfaces/browse-button-details.interface';

@Component({
	selector: 'ac-dropdown-options',
	templateUrl: './dropdown-options.component.html',
	styleUrls: ['./dropdown-options.component.scss']
})
export class DropdownOptionsComponent {

	@Input() public title: string;
	@Input() public filteredItems: Array<any> | Map<string, any[]>;
	@Input() public isGroupedDropdown: boolean = false;
	@Input() public browseButtonInformation: BrowseButtonDetails;
	@Output() public onHover = new EventEmitter();
	@Output() public onSelection = new EventEmitter();

	@HostListener('mouseenter')
	public onMouseover(): void {
		this.onHover.emit(true);
	}
	@HostListener('mouseleave')
	public onDropdownHover(): void {
		this.onHover.emit(false);
	}

	public itemSelected(item: any): void {
		this.onSelection.emit(item);
	}

	public noSort(): number {
		return 0;
	}
}
